const apiPrefix = 'ocapi/v1';
export const ocapiV1Routes = {
    prefix: apiPrefix,
    events: `${apiPrefix}/events`,
    films: `${apiPrefix}/films`,
    sites: `${apiPrefix}/sites`,
    showtimes: `${apiPrefix}/showtimes`,
    giftCards: `${apiPrefix}/gift-cards`,
    giftShop: `${apiPrefix}/gift-shop`,
    journeys: `${apiPrefix}/journeys`,
    orders: `${apiPrefix}/orders`,
    completedOrders: `${apiPrefix}/orders/completed`,
    members: `${apiPrefix}/members`,
    currentMember: `${apiPrefix}/members/current`,
    workstations: `${apiPrefix}/workstations`
};

//# sourceMappingURL=routes.js.map